/**
 * Display-only line decode for the live graph and counters. **This is not the log
 * parser.** The log stores lines byte-verbatim ([log-format.md](../docs/log-format.md))
 * and `logger.py` in the firmware repo remains the one canonical parser (REQ-CON-9,
 * shared-contract §4). This extracts numeric `key=value` fields for on-screen
 * visualisation only — best-effort, lenient, and never fed back into the log. A field it
 * misreads shows a wrong pixel, never a wrong record.
 *
 * Only plain decimals become fields, so `cr=4/5` and `sync=0x12` are skipped rather than
 * misparsed — the same generic key=value the console protocol uses.
 */
export type DecodedLine = { verb: string; fields: Record<string, number> };

const DECIMAL = /^-?\d+(?:\.\d+)?$/;

export function decodeLine(line: string): DecodedLine {
  const tokens = line.trim().split(/\s+/);
  const verb = tokens[0] ?? '';
  const fields: Record<string, number> = {};
  for (let i = 1; i < tokens.length; i++) {
    const eq = tokens[i]!.indexOf('=');
    if (eq <= 0) continue;
    const key = tokens[i]!.slice(0, eq);
    const value = tokens[i]!.slice(eq + 1);
    if (DECIMAL.test(value)) fields[key] = Number(value);
  }
  return { verb, fields };
}
